<!-- 紙本收據寄送狀態 -->
<template>
  <v-client-table
    v-if="isShow"
    name="receiptStatus"
    :data="tableData"
    :columns="tableColumns"
    :options="tableOptions"
  >
    <template #beforeTable>
      <div>
        <input
          v-model="dateFrom"
          type="date"
          placeholder="請選擇起日"
        >
        -
        <input
          v-model="dateTo"
          type="date"
          placeholder="請選擇迄日"
        >
        <Button
          small
          transparent
          @click.native="filterByDateRange"
        >
          查詢
        </Button>
      </div>
    </template>
  </v-client-table>
</template>

<script>
import { mapState } from 'vuex';
// components
import Button from '@/components/buttons/Button';

export default {
  components: {
    Button,
  },
  props: {
    currentTab: {
      type: String,
      default: '',
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    tableColumns: {
      type: Array,
      default: () => [],
    },
    tableOptions: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dateFrom: '',
      dateTo: '',
    };
  },
  computed: {
    isShow() {
      return this.currentTab === 'receiptStatus' && this.memberAreaData;
    },
    ...mapState('member', [
      'memberAreaData',
    ]),
  },
  methods: {
    filterByDateRange() {
      if(!this.dateFrom || !this.dateTo) {
        return;
      }
      this.$store.commit('receiptStatus/SET_CUSTOM_FILTER', {
        filter: 'filterByDateRange',
        value: {
          dateFrom: this.dateFrom,
          dateTo: this.dateTo,
        },
      });
    },
  },
};
</script>
